import theme from './themes/mainTheme';

import {css} from 'styled-components'

export const presets = {
    h3: (...args) => css`
      font-size: ${theme.sH3}px;
      line-height: 1.2857;
      font-weight: 600;
`,
};